import ChangePasswordComponent from '../components/change-password/changePassword.jsx'

const ChangePassword = () => <ChangePasswordComponent />

export default ChangePassword;